<template>
    <div class="col-lg-3 col-md-4 col-xs-6 mb-product">
        <ProductCard :product="product"/>
    </div>
</template>

<script>
    import ProductCard from './../../ProductCard.vue';

    export default {
        components: { ProductCard },

        props: ['product'],
    };
</script>
